<!-- =========================================================================================
  File Name: DataListThumbView.vue
  Description: Data List - Thumb View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <vx-card title="Relatório Anual">
      <div class="vx-row">
          <div class="vx-col md:w-1/2 w-1/2 mt-5">
          
          <h6 class="mb-2">Ano</h6>
          <div>
            <datepicker
              placeholder="Selecione o Ano"
              :language="languages['ptBR']"
              format="yyyy"
              v-model="year"
              :minimumView="'year'" :maximumView="'year'"
            ></datepicker>
          </div>
        </div> 
      </div>
      <br />
      <vs-button color="danger" type="filled" @click="submit">Gerar</vs-button>
    </vx-card>
    <br />
    <br />
  </div>
</template>


<script>
import Datepicker from "vuejs-datepicker";
import * as lang from "vuejs-datepicker/src/locale";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
import { momentJS } from "@/helpers";
import axios from "axios";
import { baseApiUrl } from "@/global";
const dict = {
  custom: {
    user: {
      required: "Selecione o Consultor",
    },
  },
};
Validator.localize("en", dict);
export default {
  components: {
    Datepicker,
    vSelect,
  },
  data() {
    return {
      year: null,
      languages: lang,
      customerSelected: [],
      userSelected: null,
      moment: null,
    };
  },
  computed: {
    getUsers() {
      return this.$store.state.usersFiltered;
    },
  },
  methods: {
    async submit() {
      const haveErrors = !(await this.$validator.validateAll());
      if (haveErrors) return;
      let year = this.moment.formatYear(this.year);
        
      try {
        this.$vs.loading();
        let res = await axios.get(
          `${baseApiUrl}/partsOrder/intervalReportByYear?year=${year}`,
         { responseType: "blob" }
        );

        let blob = new Blob([res.data], { type: "application/pdf" }),
        url = window.URL.createObjectURL(blob);
        window.open(url);

      } catch (error) {
        this.$vs.notify({
          title: "Erro",
          text: "Não foi possivel salvar " + error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  async created() {
    this.moment = momentJS();
    this.dateInitial = this.moment.getDateTimeLocal();
    this.dateFinal = this.dateInitial;

  },
};
</script>

<style lang="scss">
</style>
